

    (function () {
      function initCustomQuickView() {
        const modal = document.querySelector('[data-custom-quick-view]');

        /* Move Quick View outside the section so the overlay covers the header */
        document.body.appendChild(modal);

        if (!modal || modal.dataset.initialized === 'true') return;

        modal.dataset.initialized = 'true';

        const image = modal.querySelector('[data-quick-view-image]');
        const title = modal.querySelector('[data-quick-view-title]');
        const text = modal.querySelector('[data-quick-view-text]');
        const reviewsWrapper =  modal.querySelector('.custom-quick-view__reviews');
        const stars = modal.querySelector('[data-quick-view-stars]');
        const reviewText = modal.querySelector('[data-quick-view-review-text]');
        const info1 = modal.querySelector('[data-quick-view-info-1]');
        const info2 = modal.querySelector('[data-quick-view-info-2]');
        const addButton = modal.querySelector('[data-main-product-atc]');

        const quantityInput = modal.querySelector(
        '[data-quick-view-quantity-input]'
        );

        const quantityMinus = modal.querySelector(
        '[data-quantity-minus]'
        );

         const quantityPlus = modal.querySelector(
         '[data-quantity-plus]'
         );

        if (!image || !title || !text || !addButton) return;

        function getQuantity() {
  if (!quantityInput) return 1;

  let quantity = parseInt(quantityInput.value, 10);

  if (isNaN(quantity) || quantity < 1) {
    quantity = 1;
  }

  const max = parseInt(quantityInput.max, 10);

  if (max && quantity > max) {
    quantity = max;
  }

  quantityInput.value = quantity;

  return quantity;
}

function updateQuantityButtons() {
  if (!quantityInput) return;

  const quantity = getQuantity();
  const max = parseInt(quantityInput.max, 10);

  if (quantityMinus) {
    quantityMinus.disabled = quantity <= 1;
  }

  if (quantityPlus) {
    quantityPlus.disabled = max && quantity >= max;
  }
}

if (quantityMinus) {
  quantityMinus.addEventListener('click', function () {
    let quantity = getQuantity();

    if (quantity > 1) {
      quantity--;
      quantityInput.value = quantity;
    }

    updateQuantityButtons();
  });
}

if (quantityPlus) {
  quantityPlus.addEventListener('click', function () {
    let quantity = getQuantity();
    const max = parseInt(quantityInput.max, 10);

    if (!max || quantity < max) {
      quantity++;
      quantityInput.value = quantity;
    }

    updateQuantityButtons();
  });
}

if (quantityInput) {
  quantityInput.addEventListener('change', function () {
    getQuantity();
    updateQuantityButtons();
  });
}

updateQuantityButtons();

       const mainProductVariantId = parseInt(
  modal.dataset.mainProductVariantId || '0',
  10
);

const mainProductAvailable =
  modal.dataset.mainProductAvailable === 'true';

        function closeModal() {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('custom-quick-view-open');
        }

        document.addEventListener('click', function (event) {
          const quickViewButton = event.target.closest('[data-quick-view]');

          if (!quickViewButton) return;

          const productTitle = quickViewButton.dataset.productTitle || '';
          const productImage = quickViewButton.dataset.productImage || '';
          const productText = quickViewButton.dataset.productText || '';
          const productRating = parseFloat(
            quickViewButton.dataset.productRating || '0');
          const productReviewCount = parseInt(
           quickViewButton.dataset.productReviewCount || '0', 10);
          const productInfoId = quickViewButton.dataset.productInfoId;
          const productInfoElement = document.getElementById(productInfoId);

           let productInfo1 = '';
           let productInfo2 = '';

          if (productInfoElement) {

            try {

              const productInfo =
               JSON.parse(productInfoElement.textContent);

              productInfo1 = productInfo.info1 || '';
              productInfo2 = productInfo.info2 || '';

              } catch (error) {

              console.error(
                'Quick View metafield JSON error:',
              error
             );

            }

          }

          image.src = productImage;
          image.alt = productTitle;
          title.textContent = productTitle;
          text.textContent = productText;

         // METAFIELD CONTENT
         info1.innerHTML = productInfo1;
         info2.innerHTML = productInfo2;

         //hide the area if metafield empty
         info1.style.display =
         productInfo1 ? 'block' : 'none';

         info2.style.display =
         productInfo2 ? 'block' : 'none';

          // PRODUCT REVIEWS

         if (
           productReviewCount > 0 &&
           productRating > 0
           ) {

          const fullStars = Math.floor(productRating);

          const hasHalfStar =
          productRating - fullStars >= 0.5;

           let starHTML = '';

          for (let i = 0; i < fullStars; i++) {
          starHTML += '★';
          }

          if (hasHalfStar && fullStars < 5) {
          starHTML += '★';
          }

          stars.textContent = starHTML;

          reviewText.textContent =
         `${productRating.toFixed(1)} stars · ${productReviewCount} reviews`;

          reviewsWrapper.style.display = 'flex';

          } else {

        // No reviews - hide the row 
        reviewsWrapper.style.display = 'none';

        }

          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('custom-quick-view-open');
        });

        modal.addEventListener('click', function (event) {
          if (event.target.closest('[data-quick-view-close]')) {
            closeModal();
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
          }
        });

       
      addButton.addEventListener('click', async function () {

  if (!mainProductVariantId || !mainProductAvailable) {
    return;
  }

  const originalText =
    addButton.dataset.originalText ||
    addButton.textContent.trim();

  addButton.dataset.originalText = originalText;

  addButton.disabled = true;
  addButton.textContent = 'ADDING...';

  try {

    /*
     * Use Horizon's standard Shopify cart action.
     * This adds the MAIN PDP PRODUCT.
     */
    if (
      window.Shopify &&
      window.Shopify.actions &&
      typeof window.Shopify.actions.updateCart === 'function'
    ) {

      const merchandiseId =
        `gid://shopify/ProductVariant/${mainProductVariantId}`;

     const quantity = getQuantity();

const result = await window.Shopify.actions.updateCart({
  lines: [
    {
      merchandiseId: merchandiseId,
      quantity: quantity
    }
  ]
});

      /*
       * Check for cart errors.
       */
      if (
        result &&
        result.userErrors &&
        result.userErrors.length
      ) {
        throw new Error(
          result.userErrors[0].message || 'Unable to add product to cart.'
        );
      }

      /*
       * Restore button.
       */
      addButton.textContent = originalText;
      addButton.disabled = false;

      /*
       * Close Quick View first.
       */
      closeModal();

      /*
       * Open Horizon cart drawer.
       *
       * updateCart() has already updated the cart state
       * and Horizon will refresh the drawer contents.
       */
      if (
        window.Shopify.actions &&
        typeof window.Shopify.actions.openCart === 'function'
      ) {

        await window.Shopify.actions.openCart();

      } else {

        /*
         * Fallback for themes where openCart isn't available.
         */
        const cartDrawer =
          document.querySelector('cart-drawer-component');

        if (
          cartDrawer &&
          typeof cartDrawer.open === 'function'
        ) {
          cartDrawer.open();
        } else {

          const cartButton =
            document.querySelector(
              '[data-testid="cart-drawer-trigger"]'
            );

          if (cartButton) {
            cartButton.click();
          }
        }
      }

      return;
    }

    /*
     * FALLBACK
     * If Shopify.actions.updateCart is not available.
     */
      const quantity = getQuantity();

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

body: JSON.stringify({
  items: [
    {
      id: mainProductVariantId,
      quantity: quantity
    }
  ]
})
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to add main product to cart.'
      );
    }

    const cart = await response.json();

    /*
     * Get the latest cart.
     */
    const cartResponse = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    if (!cartResponse.ok) {
      throw new Error(
        'Unable to fetch updated cart.'
      );
    }

    const updatedCart =
      await cartResponse.json();

    /*
     * Try Horizon's standard CartLinesUpdateEvent.
     */
    try {

      const {
        CartLinesUpdateEvent
      } = await import('@shopify/events');

      const deferred =
        CartLinesUpdateEvent.createPromise();

      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [
            {
              merchandiseId:
                String(mainProductVariantId),
              quantity: quantity
            }
          ],
          promise: deferred.promise
        })
      );

      deferred.resolve({
        cart:
          CartLinesUpdateEvent.createCartFromAjaxResponse(
            updatedCart
          ),
        detail: {
          itemCount: updatedCart.item_count,
          source: 'custom-quick-view',
          didError: false
        }
      });

    } catch (eventError) {

      console.warn(
        'Horizon CartLinesUpdateEvent unavailable:',
        eventError
      );

      /*
       * Older/custom Horizon fallback.
       */
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              itemCount: updatedCart.item_count,
              source: 'custom-quick-view'
            }
          }
        })
      );
    }

    addButton.textContent = originalText;
    addButton.disabled = false;

    closeModal();

    /*
     * Open drawer after cart update.
     */
    const cartDrawer =
      document.querySelector('cart-drawer-component');

    if (
      cartDrawer &&
      typeof cartDrawer.open === 'function'
    ) {

      cartDrawer.open();

    } else {

      const cartButton =
        document.querySelector(
          '[data-testid="cart-drawer-trigger"]'
        );

      if (cartButton) {
        cartButton.click();
      }
    }

  } catch (error) {

    console.error(
      'Custom Quick View ATC error:',
      error
    );

    addButton.textContent = originalText;
    addButton.disabled = false;
  }

});
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCustomQuickView);
      } else {
        initCustomQuickView();
      }
    })();
